(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-h2-section"] && !Shopify.designMode) return;
  try {
    
// H2 Carousel Navigation
document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.h2-section__carousel');
  
  carousels.forEach(carousel => {
    const track = carousel.querySelector('.h2-carousel__track');
    const prevBtn = carousel.querySelector('.h2-carousel__nav--prev');
    const nextBtn = carousel.querySelector('.h2-carousel__nav--next');
    
    if (!track) return;
    
    const scrollAmount = track.offsetWidth * 0.8;
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
